// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"_2tLFXF2DQLSDNeiaVp68pg","spinContainer":"_3ONT_haGAvRHEsab2NWd5Y","customButton":"_10oA5VvdfD-oK6n9dARBsd"};